import { type ReactNode, useMemo } from "react";
import { useUserPermissions } from "~context/UserPermissionsContext";
import { type PermissionNames, PermissionOperations } from "~enums/permissions";

type Props = {
  children: ReactNode;
  permissionKeys: Array<PermissionNames>;
  permissionOptions?: Array<PermissionOperations>;
  componentToRender?: ReactNode;
};

const PermissionCheck = ({ children, componentToRender, permissionKeys = [], permissionOptions = [PermissionOperations.READ] }: Props) => {
  const { hasEveryPermission } = useUserPermissions();

  const hasPermission = useMemo(
    () => hasEveryPermission(permissionKeys.map((permissionName) => ({ permissionName, permissionOperations: permissionOptions }))),
    [permissionKeys, permissionOptions, hasEveryPermission],
  );

  if (hasPermission) {
    return children;
  }
  return componentToRender ? componentToRender : null;
};

export default PermissionCheck;
